import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import { storageHelper } from "lib/helpers";
import { withErrorBoundary } from "lib/hoc";
import { OperatorUserDatabaseSetting } from "./operator/features";

const { userKey } = constant;
const { operator } = userKey;

const UserDatabaseSetting = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorUserDatabaseSetting />;
    }
    return null;
  };
  const userDatabaseSetting = getComponent(currentUserRole);
  return userDatabaseSetting;
};

export default withErrorBoundary(UserDatabaseSetting);
